// Commercial settings. Empty values are flagged as "Pending" in the editor view
// and hidden (or replaced by neutral copy) on the published page.
export const siteConfig = {
  checkoutUrl: '', // Shared by every purchase button
  price: null as number | null, // e.g. 27
  currencyCode: 'USD',
  currencySymbol: '$',
  deliveryLabel: '', // e.g. "Instant digital access"
  deliveryDetails: '', // FAQ answer: how the buyer receives the files
  paymentTerms: '', // FAQ answer: one-time payment / refund process
  offerEyebrow: '', // e.g. "Special launch offer"
  guarantee: {
    days: null as number | null, // e.g. 7
    headline: '', // e.g. "Your purchase is 100% protected"
    terms: '', // Full guarantee conditions
  },
  legalLinks: [
    { label: 'Terms & Conditions', href: '' },
    { label: 'Privacy Policy', href: '' },
    { label: 'Refund Policy', href: '' },
    { label: 'Contact', href: '' },
  ],
};
